<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading" class="error-wrapper">
    <div class="contents-container">
      <p class="heading">{{ state.interruptionDetails.heading }}</p>
      <p class="info-text">{{ state.interruptionDetails.message }}</p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          *ngIf="state.interruptionDetails.ctaLabel"
          class="button-width"
          (click)="handleCtaClick()"
          [text]="state.interruptionDetails.ctaLabel"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
    </div>
  </div>
</div>
